export default __webpack_public_path__ + "media/images/home-bg-5a9b043be59a37ece4816290bf84d76a.jpg";